import type { IconAsset } from '../Icon.types';

export const youtube: IconAsset = {
  regular: {
    l: {
      code: (
        <path
          d='M22.5467 6.7085C22.2932 5.76601 21.5501 5.02305 20.6078 4.76926C18.8862 4.29822 11.9998 4.29822 11.9998 4.29822C11.9998 4.29822 5.11359 4.29822 3.39202 4.7514C2.46779 5.00492 1.70657 5.76614 1.45305 6.7085C1 8.42994 1 12 1 12C1 12 1 15.588 1.45305 17.2915C1.70684 18.2338 2.44966 18.9768 3.39216 19.2306C5.13172 19.7017 12 19.7017 12 19.7017C12 19.7017 18.8862 19.7017 20.6078 19.2486C21.5502 18.9949 22.2932 18.2519 22.547 17.3096C22.9999 15.588 22.9999 12.0181 22.9999 12.0181C22.9999 12.0181 23.018 8.42994 22.5467 6.7085ZM9.80727 15.2981V8.70185L15.5337 12L9.80727 15.2981Z'
          fill='currentColor'
        />
      ),
    },
    m: {
      code: (
        <path
          d='M18.7889 5.59042C18.5776 4.80501 17.9584 4.18587 17.1731 3.97439C15.7385 3.58185 9.99977 3.58185 9.99977 3.58185C9.99977 3.58185 4.26131 3.58185 2.82666 3.9595C2.05647 4.17077 1.42212 4.80512 1.21086 5.59042C0.833313 7.02495 0.833313 9.99998 0.833313 9.99998C0.833313 9.99998 0.833313 12.99 1.21086 14.4095C1.42234 15.1948 2.04136 15.814 2.82678 16.0255C4.27641 16.4181 10 16.4181 10 16.4181C10 16.4181 15.7385 16.4181 17.1731 16.0405C17.9585 15.8291 18.5776 15.21 18.7891 14.4247C19.1666 12.99 19.1666 10.0151 19.1666 10.0151C19.1666 10.0151 19.1817 7.02495 18.7889 5.59042ZM8.1727 12.7484V7.25154L12.9447 9.99998L8.1727 12.7484Z'
          fill='currentColor'
        />
      ),
    },
    s: {
      code: (
        <path
          d='M15.0312 4.47233C14.8622 3.844 14.3668 3.3487 13.7385 3.17951C12.5908 2.86548 7.99986 2.86548 7.99986 2.86548C7.99986 2.86548 3.40908 2.86548 2.26137 3.1676C1.64521 3.33661 1.13773 3.84409 0.968722 4.47233C0.666687 5.61996 0.666687 7.99999 0.666687 7.99999C0.666687 7.99999 0.666687 10.392 0.968722 11.5276C1.13791 12.1559 1.63313 12.6512 2.26146 12.8204C3.42117 13.1345 8.00003 13.1345 8.00003 13.1345C8.00003 13.1345 12.5908 13.1345 13.7385 12.8324C14.3669 12.6633 14.8622 12.168 15.0313 11.5397C15.3333 10.392 15.3333 8.01207 15.3333 8.01207C15.3333 8.01207 15.3454 5.61996 15.0312 4.47233ZM6.5382 10.1987V5.80123L10.3558 7.99999L6.5382 10.1987Z'
          fill='currentColor'
        />
      ),
    },
  },
};
